import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import b from 'b_';
import SetupPasswordStore from '../../stores/SetupPasswordStore';
import { FTBody, FTHeadline, FTInput } from '../Fuse/Text';
import { AuthBox } from './AuthLayout';
import FuseTextfield from '../FuseControls/FuseTextfield';
import FuseButton from '../FuseControls/FuseButton';
import FuseAlert from '../FuseControls/FuseAlert';
import './SetupPassword.css';

const block = b.lock('SetupPassword');

class SetupPassword extends Component {
    static propTypes = {
        setupPassword: SetupPasswordStore.PropType.isRequired,
    };

    onSubmit = (event) => {
        event.preventDefault();
        this.props.setupPassword.submit()
            .then(() => { window.location = '/console/index'; })
            .catch((error) => {
                if (error) {
                    window.location = '/console/forgot';
                }
            });
    };

    getErrorLabel() {
        const { password, passwordConfirmed, minPasswordLength } = this.props.setupPassword;
        if (!password.isTouched && !passwordConfirmed.isTouched) {
            if (!password.isValid || !passwordConfirmed.isValid) {
                return `Passwords must match and be longer than ${minPasswordLength} characters.`;
            }
        }
        return '';
    }

    getRenderAlert() {
        const bodyText = this.getErrorLabel();

        if (bodyText === '') {
            return null;
        }

        return <FuseAlert
            className={block('MarginBottom', { section: 'alert' })}
            type="danger"
            icon="error"
            centerIcon
        >
            <FTInput className={block('AlertText')}>{bodyText}</FTInput>
        </FuseAlert>;
    }

    render() {
        const { setupPassword } = this.props;
        return <AuthBox onSubmit={this.onSubmit}>
            <FTHeadline className={block('Title')}>
                Create New Password
            </FTHeadline>
            <FTBody className={block('MarginBottom', { section: 'textBody' })}>
                <span className={block('Email')}>{setupPassword.email}</span>
                <br />
                <br />
                Create a new password to gain access to
                <br />
                Proofpoint Isolation Console.
            </FTBody>
            {this.getRenderAlert()}
            <input type="hidden" name="email" value={setupPassword.email} />
            <FuseTextfield
                autoFocus
                store={setupPassword.password}
                placeholder="Enter password"
                className={block('MarginBottom', { section: 'textfield' })}
                rightIcon={setupPassword.passwordVisibility.isTrue ? 'visibility_off' : 'visibility'}
                rightIconClassName={block('VisibilityIcon')}
                onRightIconClick={setupPassword.passwordVisibility.toggle}
                type={setupPassword.passwordVisibility.isTrue ? 'text' : 'password'}
                error={this.getErrorLabel() !== ''}
                name="new_password"
                autoComplete="new-password"
            />
            <FuseTextfield
                store={setupPassword.passwordConfirmed}
                placeholder="Confirm password"
                className={block('MarginBottom', { section: 'textfield' })}
                rightIcon={setupPassword.confirmPasswordVisibility.isTrue ? 'visibility_off' : 'visibility'}
                rightIconClassName={block('VisibilityIcon')}
                onRightIconClick={setupPassword.confirmPasswordVisibility.toggle}
                type={setupPassword.confirmPasswordVisibility.isTrue ? 'text' : 'password'}
                error={this.getErrorLabel() !== ''}
                name="confirm_new_password"
                autoComplete="new-password"
            />
            <FuseButton
                submit
                type={'primary'}
                color={'blue'}
                fullWidth
                disabled={!setupPassword.canSubmit}
                loading={setupPassword.apiSubmitState.isLoading}
                onClick={this.onSubmit}
            >Login</FuseButton>
        </AuthBox>;
    }
}

export default translate()(inject('setupPassword')(observer(SetupPassword)));
